export const CHAT_AUDIO_URLS = {
  COMPLETION_MESSAGE: "https://go-safe-dev-files.s3.us-east-2.amazonaws.com/audio/text/20251030195758.mp3",
  CONSENT_ACCEPTED: "https://go-safe-dev-files.s3.us-east-2.amazonaws.com/audio/text/20251030200219.mp3",
  CONSENT_REJECTED: "https://go-safe-dev-files.s3.us-east-2.amazonaws.com/audio/text/20251030200110.mp3",
};